import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import { SalesTaxModal, withProviders } from '../../../modules/core/components';
export default angular
    .module('doxy.common.components.salesTaxModal', [])
    .component('salesTaxModal', {
    template: `<div></div>`,
    bindings: {
        type: '@',
        translateValues: '<',
        imageLink: '@',
        customerId: '<'
    },
    controller: function ($element, $translate) {
        const props = {
            type: this.type,
            values: this.translateValues,
            imageLink: this.imageLink,
            customerId: this.customerId
        };
        ReactDOM.render(React.createElement(withProviders(SalesTaxModal), props), $element[0]);
    }
}).name;
